import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

function Toaster(props: ToasterProps) {
	const { resolvedTheme } = useTheme();
	return (
		<Sonner
			theme={resolvedTheme === "dark" ? "dark" : "light"}
			position="bottom-right"
			toastOptions={{
				classNames: {
					toast:
						"!rounded-lg !border !border-border !bg-popover !text-popover-foreground !shadow-lg !text-[13px]",
					description: "!text-muted-foreground",
				},
			}}
			{...props}
		/>
	);
}

export { Toaster };
